import { render, staticRenderFns } from "./DownloadAttachmentDropDown.vue?vue&type=template&id=3c1c8516&scoped=true&"
import script from "./DownloadAttachmentDropDown.vue?vue&type=script&lang=js&"
export * from "./DownloadAttachmentDropDown.vue?vue&type=script&lang=js&"
import style0 from "./DownloadAttachmentDropDown.vue?vue&type=style&index=0&id=3c1c8516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1c8516",
  null
  
)

component.options.__file = "DownloadAttachmentDropDown.vue"
export default component.exports